var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidepath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 384 512",
    style: {
      enableBackground: "new 0 0 384 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#68995D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 194,
    cy: 178.5,
    rx: 146.7,
    ry: 140.1
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194,512c0,0,192-208,192-320C386,86,300,0,194,0S2,86,2,192C2,304,194,512,194,512z M192.1,45.6 c71.5,0,129.4,57.9,129.4,129.4s-57.9,129.4-129.4,129.4S62.7,246.4,62.7,175S120.6,45.6,192.1,45.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M183.2,85.9h-25.3c-9.2,0-17.4,5.8-20.4,14.4L97.5,213c-0.7,2-1,4.1-1,6.2c0,10.2,8.3,18.5,18.5,18.5h68.2 v-21.7c0-6,4.8-10.8,10.8-10.8c6,0,10.8,4.8,10.8,10.8v21.7H273c10.2,0,18.5-8.3,18.5-18.5c0-2.1-0.4-4.2-1-6.2l-39.9-112.6 c-3.1-8.6-11.2-14.4-20.4-14.4h-25.3v21.7c0,6-4.8,10.8-10.8,10.8c-6,0-10.8-4.8-10.8-10.8V85.9z M204.8,150.9v21.7 c0,6-4.8,10.8-10.8,10.8c-6,0-10.8-4.8-10.8-10.8v-21.7c0-6,4.8-10.8,10.8-10.8C200,140.1,204.8,144.9,204.8,150.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidepath);
export default __webpack_public_path__ + "static/media/sidepath.e6200aaf796e108ee16a7f058752b9c5.svg";
export { ForwardRef as ReactComponent };